
import {
  GET_SALE_ADJUSTMENT_PRINT_REQUEST,
  GET_SALE_ADJUSTMENT_PRINT_SUCCESS,
  GET_SALE_ADJUSTMENT_PRINT_ERROR,
} from "../actions/types";


export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SALE_ADJUSTMENT_PRINT_REQUEST:
      return {
        loading: true,
      };
    case GET_SALE_ADJUSTMENT_PRINT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_SALE_ADJUSTMENT_PRINT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};